import Joi from "joi";

function isValid(object){
    console.log(object.longDescription);
    console.log(object.description);
    
    const schema = Joi.object({
        price: Joi.number().greater(0).required(),
        points: Joi.number().greater(0).required(),
        discountAmount: Joi.number().greater(0).required(),
        description:Joi.string().min(2).required(),
        longDescription:Joi.string().min(2).required(),
    })
    return schema.validate(object);
}
export {isValid};